import {
  Server, Headphones, MapPin, MonitorSmartphone, Users2, Rocket,
  ShieldCheck, Radar, ScanEye, Network, Mail, Fingerprint, KeyRound, ShieldAlert, Globe,
  Cloud, FileStack, MessagesSquare, DatabaseBackup, RefreshCw,
  Router, Wifi, QrCode, Cable, PhoneCall, Video,
  Signal, Smartphone, PhoneForwarded,
  Building2, Scale, HeartPulse, GraduationCap, ShoppingBag, Landmark,
  Clock, TrendingUp, Zap, Lock, Eye, Gauge,
} from "lucide-react";

// Routes for each top-level category
export const ROUTES = {
  "managed-it": "/managed-it",
  cyber: "/cyber-security",
  cloud: "/cloud-microsoft",
  network: "/network-consultancy",
  surveillance: "/surveillance-data",
  connectivity: "/connectivity-telecoms",
};

// Full mega-menu structure mirrored from CLI Secure content.
const MENU_RAW = [
  {
    key: "managed-it",
    label: "Managed IT",
    href: "/managed-it",
    layout: "flagship",
    eyebrow: "managed it services",
    flagship: {
      badge: "FLAGSHIP",
      title: "CLI 360",
      accent: "360",
      href: "/managed-it",
      desc: "One fully-managed platform bringing support, security, cloud and automation together — built for growing SMEs.",
      cta: "Explore CLI 360",
    },
    items: [
      { title: "IT Support London", desc: "24/7 helpdesk, London-based team", icon: Headphones, href: "/it-support-london" },
      { title: "Onsite IT Support", desc: "Field engineers across Greater London", icon: MapPin, href: "/onsite-it-support" },
      { title: "Remote IT Support", desc: "95% of issues resolved remotely", icon: MonitorSmartphone, href: "/remote-it-support" },
      { title: "Co-Managed IT Support", desc: "Works alongside your in-house IT", icon: Users2, href: "/co-managed-it-support" },
      { title: "Project Delivery & Professional Services", desc: "Migrations, rollouts & one-off projects", icon: Rocket, href: "/project-delivery" },
    ],
  },
  {
    key: "cyber",
    label: "Cyber Security",
    href: "/cyber-security",
    layout: "grid3",
    eyebrow: "cyber security",
    items: [
      { title: "Endpoint Security / EDR", desc: "Powered by SentinelOne", icon: ShieldCheck, href: "/endpoint-security-edr" },
      { title: "Managed Detection & Response", desc: "SentinelOne + 24/7 SOC", icon: Radar, href: "/managed-detection-response" },
      { title: "Managed SIEM & SOC", desc: "24/7 log monitoring & response", icon: ScanEye, href: "/managed-siem-soc" },
      { title: "Network Security", desc: "Fortinet · Cisco · Aruba & more", icon: Network, href: "/network-security" },
      { title: "Email Security", desc: "Advanced threat protection", icon: Mail, href: "/email-security" },
      { title: "Identity Protection", desc: "Mirket MFA · SSO · passwordless", icon: Fingerprint, href: "/identity-protection" },
      { title: "Privileged Access Management", desc: "Powered by Mirket PAM", icon: KeyRound, href: "/privileged-access-management" },
      { title: "Managed DMARC", desc: "Stop domain spoofing", icon: ShieldAlert, href: "/managed-dmarc" },
      { title: "Dark Web Monitoring", desc: "Credential exposure alerts", icon: Globe, href: "/dark-web-monitoring" },
    ],
  },
  {
    key: "cloud",
    label: "Cloud & Microsoft",
    href: "/cloud-microsoft",
    layout: "grid3",
    eyebrow: "cloud & microsoft 365",
    items: [
      { title: "Microsoft 365 Support", desc: "Day-to-day M365 management", icon: Cloud, href: "/microsoft-365-support" },
      { title: "Microsoft 365 Migration", desc: "Zero-downtime migration", icon: RefreshCw, href: "/microsoft-365-migration" },
      { title: "SharePoint Consultancy", desc: "Intranet & document management", icon: FileStack, href: "/sharepoint-consultancy" },
      { title: "Teams Consultancy", desc: "Collaboration & Teams Phone", icon: MessagesSquare, href: "/teams-consultancy" },
      { title: "Cloud Backup Solutions", desc: "Veeam · Acronis · Cove", icon: DatabaseBackup, href: "/cloud-backup-solutions" },
    ],
  },
  {
    key: "network",
    label: "Network Consultancy",
    href: "/network-consultancy",
    layout: "flagship",
    eyebrow: "design · deploy · support",
    flagship: {
      badge: "FLAGSHIP",
      title: "Wifinger",
      accent: "finger",
      href: "/guest-wifi",
      desc: "Our own guest Wi-Fi platform: a branded login page on the access points you already have, plus consent, analytics and marketing — designed, installed and managed by us.",
      cta: "Explore guest Wi-Fi",
    },
    items: [
      { title: "Cisco Network Consultancy", desc: "Switching, routing & security", icon: Router, href: "/cisco-network-consultancy" },
      { title: "Aruba Network Consultancy", desc: "Wired & wireless infrastructure", icon: Network, href: "/aruba-network-consultancy" },
      { title: "Fortinet Network Consultancy", desc: "Secure SD-WAN & firewalls", icon: ShieldCheck, href: "/fortinet-network-consultancy" },
      { title: "Grandstream Consultancy", desc: "VoIP & networking hardware", icon: PhoneCall, href: "/grandstream-network-consultancy" },
      { title: "Wireless Network Consultancy", desc: "Site surveys & Wi-Fi design", icon: Wifi, href: "/wireless-network-consultancy" },
      { title: "Guest Wi-Fi", desc: "Captive portal, consent & analytics", icon: QrCode, href: "/guest-wifi" },
    ],
  },
  {
    key: "surveillance",
    label: "Surveillance & Data",
    href: "/surveillance-data",
    layout: "grid2",
    eyebrow: "surveillance & data infrastructure",
    items: [
      { title: "Data Cabling Installation", desc: "Cat6 / Cat6a & fibre structured cabling", icon: Cable, href: "/data-cabling" },
      { title: "Cloud CCTV Management", desc: "AI cloud video, powered by Brivo", icon: Video, href: "/cloud-cctv" },
    ],
  },
  {
    key: "connectivity",
    label: "Connectivity & Telecoms",
    href: "/connectivity-telecoms",
    layout: "columns",
    eyebrow: "connectivity & telecoms",
    columns: [
      {
        head: "leased lines & wan",
        title: "Business Internet & Leased Lines",
        blurb: "Dedicated, SLA-backed connectivity that keeps every site online — from ultrafast full fibre and uncontended leased lines to intelligent SD-WAN and automatic 4G/5G failover.",
        items: [
          { title: "Leased Lines", desc: "Dedicated, uncontended fibre", icon: Cable, href: "/leased-lines" },
          { title: "Dedicated Internet Access", desc: "Guaranteed, SLA-backed", icon: Gauge, href: "/dedicated-internet-access" },
          { title: "FTTP & Full Fibre", desc: "Ultrafast full fibre", icon: Zap, href: "/fttp-leased-line" },
          { title: "SD-WAN", desc: "Intelligent multi-site WAN", icon: Router, href: "/sd-wan" },
          { title: "Multi-Site Connectivity", desc: "One secure network", icon: Network, href: "/multi-site-connectivity" },
          { title: "Backup Connectivity", desc: "Automatic 4G/5G failover", icon: RefreshCw, href: "/backup-connectivity" },
        ],
      },
      {
        head: "mobile",
        title: "Business Mobile & SIMs",
        blurb: "Flexible airtime and data on O2, Vodafone and EE — from single SIM-only plans and mobile broadband to shared data pools and static-IP SIMs for IoT and failover.",
        items: [
          { title: "Business Mobiles", desc: "O2, Vodafone & EE airtime", icon: Smartphone, href: "/business-mobile-sim" },
          { title: "SIM Only Deals", desc: "Flexible 30-day & 24-month", icon: Signal, href: "/sim-only-deals" },
          { title: "Mobile Broadband", desc: "4G / 5G data-only SIMs", icon: Wifi, href: "/mobile-broadband" },
          { title: "Static IP SIMs", desc: "Fixed IP for IoT & failover", icon: Globe, href: "/mobile-broadband#static-ip" },
        ],
      },
      {
        head: "telecoms",
        title: "Cloud Telephony & VoIP",
        blurb: "Modern business phone systems — cloud-hosted PBX, Microsoft Teams calling, international phone numbers, CRM click-to-dial and 24/7 AI voice agents.",
        items: [
          { title: "Cloud Hosted PBX", desc: "VoIP phone system, powered by Voipinger", icon: PhoneCall, href: "/cloud-hosted-pbx" },
          { title: "SIP Trunking", desc: "Connect your PBX, cut call costs", icon: PhoneCall, href: "/sip-trunk" },
          { title: "Microsoft Teams Phone", desc: "Calling inside Teams", icon: MessagesSquare, href: "/teams-phone-system" },
          { title: "Business Phone Numbers", desc: "Local numbers in 145+ countries", icon: PhoneForwarded, href: "/phone-numbers" },
          { title: "CRM Integration", desc: "250+ apps, click-to-dial", icon: MonitorSmartphone, href: "/integrations" },
          { title: "AI Receptionist", desc: "24/7 AI voice agent", icon: Headphones, href: "/ai-receptionist" },
          { title: "AI Contact Center", desc: "AI voice & chat at scale", icon: Users2, href: "/ai-contact-center" },
        ],
      },
    ],
  },
];

// Menu display order: Managed IT · Connectivity · Cyber · Cloud · Network · Surveillance
const MENU_ORDER = ["managed-it", "connectivity", "cyber", "cloud", "network", "surveillance"];
export const MENU = MENU_ORDER.map((k) => MENU_RAW.find((m) => m.key === k)).filter(Boolean);

export const SIMPLE_LINKS = [
  { label: "About", href: "/about" },
  { label: "Resources", href: "/resources" },
  { label: "Shop", href: "https://shop.clisecure.com" },
];

export const SERVICE_ICONS = {
  "managed-it": Server,
  cyber: ShieldCheck,
  cloud: Cloud,
  network: Network,
  surveillance: ScanEye,
  connectivity: Signal,
};

export const CONTACT = {
  phone: "020 3355 1151",
  email: "info@clisecure.com",
  supportEmail: "support@clisecure.com",
  address: "London, United Kingdom",
};

// ---- Rich content for generated service pages (keyed by route slug) ----
export const SERVICE_PAGES = {
  "cyber-security": {
    menuKey: "cyber",
    label: "Cyber Security",
    eyebrow: "cyber security · london",
    headline: "Threat-led security that never clocks off",
    sub: "A layered defence built around your business — endpoint, network, email and identity — monitored 24/7 by a real UK SOC.",
    image: "/svc-cyber-security.webp",
    imageAlt: "Crystal padlock shield",
    intro: {
      heading: "Defence in depth, without the complexity",
      body: "Attackers only need one gap. We close them across every layer and watch the rest around the clock, so a stray click never becomes a breach.",
      bullets: ["SentinelOne EDR on every endpoint", "24/7 SOC with human analysts", "Cyber Essentials & ISO 27001 alignment"],
    },
    benefits: [
      { icon: Radar, t: "24/7 detection", d: "Human-led SOC triages every alert, day or night." },
      { icon: Lock, t: "Zero-trust identity", d: "MFA, SSO and PAM to lock down access." },
      { icon: ShieldAlert, t: "Breach containment", d: "Automated isolation stops lateral spread fast." },
      { icon: Gauge, t: "Compliance ready", d: "Evidence and reporting for audits and insurers." },
    ],
    process: [
      { k: "01", t: "Security assessment", d: "We map your attack surface and prioritise the real risks." },
      { k: "02", t: "Deploy & harden", d: "EDR, email and identity controls rolled out across the estate." },
      { k: "03", t: "Monitor 24/7", d: "Our SOC watches, triages and responds to threats in real time." },
      { k: "04", t: "Report & improve", d: "Monthly posture reviews keep you ahead of attackers." },
    ],
    faqs: [
      { q: "Do you provide a real Security Operations Centre?", a: "Yes — our SOC is staffed by human analysts 24/7/365, backed by SentinelOne and SIEM tooling, not just automated alerts." },
      { q: "Can you help us achieve Cyber Essentials?", a: "Absolutely. We align your controls to Cyber Essentials, Cyber Essentials Plus and ISO 27001, and provide the evidence needed for certification." },
      { q: "What happens when an incident is detected?", a: "Threats are automatically contained at the endpoint, our SOC investigates immediately, and you receive a clear incident report with remediation steps." },
    ],
    partners: ["SentinelOne", "Fortinet", "Guardz", "Mirket"],
  },
  "cloud-microsoft": {
    menuKey: "cloud",
    label: "Cloud & Microsoft 365",
    eyebrow: "cloud & microsoft 365 · london",
    headline: "Get the most out of Microsoft 365",
    sub: "Migration, management and consultancy for M365, SharePoint and Teams — with backup and disaster recovery built in.",
    image: "/svc-cloud-microsoft.webp",
    imageAlt: "Crystal cloud",
    intro: {
      heading: "Cloud done properly, secured by default",
      body: "We migrate you with zero downtime, tune licensing so you stop overpaying, and protect your data with immutable backups.",
      bullets: ["Zero-downtime M365 migrations", "Right-sized, cost-optimised licensing", "Immutable cloud backup & DR"],
    },
    benefits: [
      { icon: RefreshCw, t: "Seamless migration", d: "Move email, files and Teams with no disruption." },
      { icon: DatabaseBackup, t: "Backup & DR", d: "M365 data protected against loss and ransomware." },
      { icon: Users2, t: "Adoption support", d: "Training so your team actually uses the tools." },
      { icon: TrendingUp, t: "Cost control", d: "Licensing reviews that cut wasted spend." },
    ],
    process: [
      { k: "01", t: "Discovery", d: "Audit your tenant, licences, data and security posture." },
      { k: "02", t: "Plan & pilot", d: "A staged migration plan with a pilot group first." },
      { k: "03", t: "Migrate", d: "Cutover out of hours with full rollback safety." },
      { k: "04", t: "Optimise", d: "Ongoing management, backup and adoption support." },
    ],
    faqs: [
      { q: "Will we lose email during migration?", a: "No. We run migrations out of hours with coexistence, so mailboxes stay live and nothing is lost during cutover." },
      { q: "Doesn't Microsoft back up my 365 data?", a: "Microsoft protects the platform, not your data long-term. We add immutable backups so you can recover from accidental deletion or ransomware." },
      { q: "Can you help reduce our licensing costs?", a: "Yes. Our licensing reviews commonly identify unused or over-provisioned licences and right-size your plan." },
    ],
    partners: ["Microsoft 365", "SharePoint", "Teams", "Azure"],
  },
  "network-consultancy": {
    menuKey: "network",
    label: "Network Consultancy",
    eyebrow: "design · deploy · support",
    headline: "Networks designed to scale, built to last",
    sub: "Vendor-certified consultancy across Cisco, Aruba and Fortinet — from site surveys to secure SD-WAN and Wi-Fi.",
    image: "/svc-network-consultancy.webp",
    imageAlt: "Crystal network nodes",
    intro: {
      heading: "Infrastructure that just works — everywhere",
      body: "We design resilient, secure networks and prove they perform, so connectivity is never the reason your business slows down.",
      bullets: ["Cisco, Aruba & Fortinet certified", "Predictive Wi-Fi site surveys", "Secure SD-WAN for multi-site"],
    },
    benefits: [
      { icon: Network, t: "Resilient design", d: "Redundant, high-availability architecture." },
      { icon: Wifi, t: "Wi-Fi that works", d: "Surveyed and tuned for real-world coverage." },
      { icon: ShieldCheck, t: "Secure by design", d: "Segmentation and next-gen firewalling built in." },
      { icon: Gauge, t: "Performance proven", d: "We test and document before handover." },
    ],
    process: [
      { k: "01", t: "Survey & design", d: "Site surveys and a documented target architecture." },
      { k: "02", t: "Procure", d: "Vendor-optimised hardware sourced at the right price." },
      { k: "03", t: "Deploy", d: "Clean installation with minimal disruption." },
      { k: "04", t: "Support", d: "Ongoing monitoring and proactive maintenance." },
    ],
    faqs: [
      { q: "Which vendors do you work with?", a: "We hold certifications across Cisco, Aruba, Fortinet and Grandstream, and recommend the best fit for your needs and budget." },
      { q: "Do you carry out Wi-Fi site surveys?", a: "Yes — predictive and on-site surveys ensure full coverage and capacity before a single access point is installed." },
      { q: "Can you support multi-site businesses?", a: "Definitely. We design secure SD-WAN and VPN topologies that connect all your locations reliably and securely." },
    ],
    partners: ["Cisco", "Aruba", "Fortinet", "Grandstream"],
  },
  "surveillance-data": {
    menuKey: "surveillance",
    label: "Surveillance & Data",
    eyebrow: "surveillance & data infrastructure",
    headline: "Structured cabling & cloud CCTV, done right",
    sub: "Future-proof Cat6/fibre cabling and cloud-managed CCTV that you can monitor from anywhere.",
    image: "https://static.prod-images.emergentagent.com/jobs/98e461ea-dd4a-4483-ac15-ef5666212b41/images/45ebe507de2b946fddf9154bd0cc638c131917e10fe498c8147d1a7176cd35c8.png",
    imageAlt: "Cloud-managed CCTV and structured data cabling network",
    intro: {
      heading: "The physical layer your business depends on",
      body: "Great connectivity and security start with the cabling in the walls and the cameras on the ceiling. We install both to a certified standard.",
      bullets: ["Cat6 / Cat6a & fibre structured cabling", "Cloud CCTV via Eagle Eye & Brivo", "Certified, warrantied installations"],
    },
    benefits: [
      { icon: Cable, t: "Certified cabling", d: "Tested, labelled and warrantied to standard." },
      { icon: Video, t: "Cloud CCTV", d: "Watch any site, live, from any device." },
      { icon: Eye, t: "Smart alerts", d: "Motion and analytics keep you informed." },
      { icon: ShieldCheck, t: "Secure access", d: "Cloud access control with full audit trails." },
    ],
    process: [
      { k: "01", t: "Site survey", d: "We assess layout, cable routes and camera coverage." },
      { k: "02", t: "Design", d: "A documented plan for cabling and CCTV placement." },
      { k: "03", t: "Install", d: "Neat, certified installation with minimal disruption." },
      { k: "04", t: "Handover", d: "Testing, labelling and cloud access set up for you." },
    ],
    faqs: [
      { q: "What cabling standards do you install to?", a: "We install and certify Cat6, Cat6a and fibre structured cabling, fully tested and warrantied for peace of mind." },
      { q: "Can I view CCTV remotely?", a: "Yes. Our cloud CCTV platforms (Eagle Eye, Brivo) let you view live and recorded footage securely from any device." },
      { q: "Do you handle both cabling and cameras?", a: "We deliver the full physical layer — structured cabling, CCTV and cloud access control — as one coordinated project." },
    ],
    partners: ["Eagle Eye", "Brivo", "Cat6a", "Fibre"],
  },
  "connectivity-telecoms": {
    menuKey: "connectivity",
    label: "Connectivity & Telecoms",
    eyebrow: "connectivity & telecoms · london",
    headline: "Business connectivity you can rely on",
    sub: "Fibre broadband, leased lines, business mobile and cloud telephony — one partner for every connection.",
    image: "/svc-connectivity-telecoms.webp",
    imageAlt: "Crystal globe",
    servicesHeading: "One partner for business internet, mobile & phone systems",
    servicesIntro: "Most London businesses juggle a broadband provider, a mobile network and a phone-system vendor — then chase three help desks when something breaks. CLI Secure brings connectivity and telecoms under one roof, so your internet, business mobile and cloud telephony are designed, installed and supported by a single accountable UK team. Explore each service below.",
    intro: {
      heading: "Always-on connectivity and calling",
      body: "From ultrafast full fibre to VoIP and Teams Phone, we keep your business connected and talking — with SLAs that mean it.",
      bullets: ["Full fibre (FTTP) & leased lines", "VoIP & Microsoft Teams Phone", "Business mobile on Vodafone & O2"],
    },
    benefits: [
      { icon: Signal, t: "Ultrafast fibre", d: "Symmetrical, future-proof connectivity." },
      { icon: PhoneCall, t: "Cloud telephony", d: "VoIP and Teams Phone that scale with you." },
      { icon: Smartphone, t: "Business mobile", d: "Flexible airtime and SIM-only deals." },
      { icon: Clock, t: "Guaranteed SLAs", d: "Dedicated bandwidth with real uptime promises." },
    ],
    process: [
      { k: "01", t: "Assess", d: "We check availability and your bandwidth needs." },
      { k: "02", t: "Quote", d: "The right circuit and telephony plan for your budget." },
      { k: "03", t: "Install", d: "Provisioning and porting managed end-to-end." },
      { k: "04", t: "Support", d: "Proactive monitoring and rapid fault resolution." },
    ],
    faqs: [
      { q: "How fast can I get full fibre installed?", a: "Lead times vary by location, but we manage the whole provisioning process and keep you updated at every step." },
      { q: "Can you port our existing phone numbers?", a: "Yes — we port local, national and 0800 numbers to our cloud telephony with no loss of service." },
      { q: "Do you offer guaranteed bandwidth?", a: "Our leased lines provide dedicated, symmetrical bandwidth backed by strict uptime SLAs." },
    ],
    partners: ["Voipinger", "Vodafone", "O2", "Teams Phone"],
  },
};

export const INDUSTRIES = [
  { icon: Scale, t: "Legal", d: "Secure, compliant IT for law firms and chambers." },
  { icon: Landmark, t: "Finance", d: "Resilient infrastructure for FCA-regulated firms." },
  { icon: HeartPulse, t: "Healthcare", d: "Data-protected systems for clinics and practices." },
  { icon: ShoppingBag, t: "Retail & Hospitality", d: "Connected stores, tills and Wi-Fi that scale." },
  { icon: GraduationCap, t: "Education", d: "Safe, managed IT for schools and colleges." },
  { icon: Building2, t: "Professional Services", d: "Reliable IT for agencies and consultancies." },
];

export const INSIGHTS = [
  {
    tag: "Cyber Security",
    title: "Why 24/7 monitoring beats antivirus in 2026",
    excerpt: "Traditional AV can't keep up with modern threats. Here's what a managed SOC actually changes.",
    image: "https://images.unsplash.com/photo-1614064641938-3bbee52942c7?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    read: "5 min read",
  },
  {
    tag: "Cloud",
    title: "The hidden cost of unmanaged Microsoft 365",
    excerpt: "Overspending on licences and missing backups are more common than you think. A quick audit guide.",
    image: "https://images.pexels.com/photos/37730212/pexels-photo-37730212.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=520&w=800",
    read: "4 min read",
  },
  {
    tag: "Managed IT",
    title: "Switching IT providers without the downtime",
    excerpt: "A practical playbook for a zero-disruption handover to a new managed IT partner.",
    image: "https://images.unsplash.com/photo-1544197150-b99a580bb7a8?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    read: "6 min read",
  },
];
